var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcPrivacyOptionsGreen = function SvgIcPrivacyOptionsGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#18A474",
    clipPath: "url(#icPrivacyOptionsGreen_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.236.1h21.497c5.374 0 9.9 4.384 9.9 9.9s-4.384 9.9-9.9 9.9H11.236a9.84 9.84 0 0 1-9.9-9.9 9.84 9.84 0 0 1 9.9-9.9m0 1.697C6.71 1.797 3.033 5.474 3.033 10s3.677 8.203 8.203 8.203h9.617l4.384-16.406zm25.259 5.587c.282-.283.282-.849 0-1.132-.283-.283-.849-.283-1.132 0l-3.111 3.112-3.112-3.112c-.283-.283-.848-.283-1.131 0s-.283.849 0 1.132l3.111 3.111-2.97 3.112c-.283.282-.283.848 0 1.13.283.284.849.284 1.132 0l3.111-3.11 3.111 3.11c.283.284.85.284 1.132 0 .283-.282.283-.848 0-1.13l-3.111-3.112z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.732 5.898c.283.283.424.849.141 1.132l-5.94 6.93c-.141.141-.283.283-.424.283-.283.141-.707.141-.99-.142L8.408 10.99c-.283-.283-.283-.849 0-1.132.282-.283.848-.283 1.13 0l2.547 2.405 5.374-6.365c.283-.282.849-.282 1.273 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icPrivacyOptionsGreen_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.77.1H43.2v19.8H.77z"
  })))));
};
export default SvgIcPrivacyOptionsGreen;